import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container ct-example-row mb-4" }
const _hoisted_2 = { class: "row flex-row" }
const _hoisted_3 = { class: "col-sm-12 col-md-6 mb-1" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "mx-3" }
const _hoisted_6 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Teléfono ", -1)
const _hoisted_8 = { class: "col-sm-12 col-md-6 mt-1" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "mx-3" }
const _hoisted_11 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Nombre completo ", -1)
const _hoisted_13 = { class: "col-sm-12 col-md-6 mb-1" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "mx-3" }
const _hoisted_16 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Email ", -1)
const _hoisted_18 = { class: "col-sm-12 col-md-6 mt-1" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "mx-3" }
const _hoisted_21 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " NIT/Número Afiliado ", -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "mx-3" }
const _hoisted_27 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Empresa ", -1)
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "mx-3" }
const _hoisted_32 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Dirección ", -1)
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = { class: "mx-3" }
const _hoisted_38 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Tipo de llamada ", -1)
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "mx-3" }
const _hoisted_43 = { class: "text-dark font-weight-600 text-sm" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("small", { class: "d-block text-muted" }, " Cola de llamada ", -1)

import {
	Phone,
	User,
	LocationInformation,
	School,
	Message,
	Postcard,
	Guide,
	Switch,
} from "@element-plus/icons";
import { CallDataModule } from "@/store/modules/CallData";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const iconOpt = { color: "#5D72E2", size: 26 };
const loading = computed(() => {
	return CallDataModule.loadingSK;
});
const activeCall = computed(() => {
	return CallDataModule.activeCall;
});
const user = computed(() => {
	return CallDataModule.user;
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, {
            size: iconOpt.size,
            color: iconOpt.color,
            class: "no-inherit"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Phone))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 1,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(activeCall).call_number), 1),
                _hoisted_7
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_icon, {
            size: iconOpt.size,
            color: iconOpt.color,
            class: "no-inherit"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(User))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 1,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("a", _hoisted_11, _toDisplayString(_unref(user)?.customer?.full_name), 1),
                _hoisted_12
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createVNode(_component_el_divider),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_icon, {
            size: iconOpt.size,
            color: iconOpt.color,
            class: "no-inherit"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Message))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 1,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("a", _hoisted_16, _toDisplayString(_unref(user)?.email), 1),
                _hoisted_17
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_icon, {
            size: iconOpt.size,
            color: iconOpt.color,
            class: "no-inherit"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Postcard))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 1,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("a", _hoisted_21, _toDisplayString(_unref(user)?.dui_nit), 1),
                _hoisted_22
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_icon, {
            size: iconOpt.size,
            color: iconOpt.color,
            class: "no-inherit"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(School))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 1,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("a", _hoisted_27, _toDisplayString(_unref(user)?.company_name), 1),
                _hoisted_28
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_el_icon, {
            size: iconOpt.size,
            color: iconOpt.color,
            class: "no-inherit"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LocationInformation))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 1,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("a", _hoisted_32, _toDisplayString(_unref(user)?.address), 1),
                _hoisted_33
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_el_icon, {
            size: iconOpt.size,
            color: iconOpt.color,
            class: "no-inherit"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Guide))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 1,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("a", _hoisted_38, _toDisplayString(_unref(activeCall).call_type), 1),
                _hoisted_39
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_el_icon, {
            size: iconOpt.size,
            color: iconOpt.color,
            class: "no-inherit"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Switch))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 1,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("a", _hoisted_43, _toDisplayString(_unref(activeCall).queue), 1),
                _hoisted_44
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ]))
}
}

})